import QuoteRepository from './QuoteRepository';
const repositories = {
  quote_repository: QuoteRepository,
};

// eslint-disable-next-line import/prefer-default-export
export const RepositoryFactory = {
  get: name => repositories[name],
};
